/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserSearchByString } from '../../models/user-search-by-string';
import { UserTagWithEmail } from '../../models/user-tag-with-email';

export interface SearchUserWithEmail$Params {
      body: UserSearchByString
}

export function searchUserWithEmail(http: HttpClient, rootUrl: string, params: SearchUserWithEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserTagWithEmail>>> {
  const rb = new RequestBuilder(rootUrl, searchUserWithEmail.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserTagWithEmail>>;
    })
  );
}

searchUserWithEmail.PATH = '/rest/admin/search-user';
